import React from "react";

import CheckboxSettingSection from "Signups/FamilyRegistration/Shared/CheckboxSettingSection";
import Dropdown from "Signups/FamilyRegistration/Shared/Dropdown";
import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import ErrorMessage from "Signups/FamilyRegistration/Shared/ErrorMessage";
import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";
import API from "Signups/FamilyRegistration/API";

export default function RegistrationGroupChildren({ disabled }) {
  const { state, dispatch } = useFamilyRegistrationContext();
  const { updateSetting, error } = useUpdateSetting();

  let availableGroups =
    state?.familyRegistrationSettings?.registrationGroupChildren
      ?.availableGroups;

  const selectedGroupID =
    state?.familyRegistrationSettings?.registrationGroupChildren
      ?.selectedGroupID;

  async function onSelect(groupID) {
    await updateSetting({
      setting: "registrationGroupChildren",
      itemID: groupID,
      value: groupID,
    });
  }

  async function handleClick(listIsOpen) {
    if (!listIsOpen) {
      const resp = await API.getAvailableGroups().post();
      dispatch({
        type: "setRegistrationGroupsChildrenAvailableGroups",
        payload: resp.availableGroups,
      });
    }
  }

  return (
    <CheckboxSettingSection
      setting="registrationGroupChildren"
      label="Put newly registered children in a group"
      disabled={disabled}
    >
      <div style={{ maxWidth: "360px" }} data-cy="regChildrenGroupDropdown">
        <Dropdown
          nameKey="groupName"
          idKey="groupID"
          placeholder={"Select a group"}
          options={availableGroups}
          onSelect={onSelect}
          onClick={handleClick}
          initialSelectedId={selectedGroupID}
        />
      </div>
      <div
        style={{ fontSize: "12px", marginTop: "6px" }}
        data-cy="registeredEveryoneChildrenGroupMsg"
      >
        Everyone who registers will be put in the Everyone group.
      </div>
      <ErrorMessage error={error?.error} marginLeft="0px" />
    </CheckboxSettingSection>
  );
}
